import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  subscription WaitTimeoutMessage($id: ID!) {
    waitTimeoutMessage(id: $id, forExpert: false, forUser: true) {
      text
      metadata
    }
  }
`);
